import { INVOICE_LIST } from "./type";

const initialState = {
  invoiceList: {}
};

const InvoiceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INVOICE_LIST:
      return {
        ...state,
        invoiceList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default InvoiceReducer;
